module.exports = __webpack_public_path__ + "static/img/i72.f4dac4fe.png";